import {createSlice} from "@reduxjs/toolkit";
import {
    onSidebarInOrdersChange,
    onSidebarIsOpenChange,
    onSidebarItemsChange,
    onSidebarSidebarWithNavigateChange,
    SidebarItem,
    SidebarState
} from "../reducers/sidebar-reducers";

export const sidebarSlice = createSlice({
    name: "sidebar",
    initialState: {
        items: [] as SidebarItem[],
        inOrders: false,
        withNavigate: false,
        isOpen: true
    } as SidebarState,
    reducers: {
        changeSidebarItems: ((state, action) => onSidebarItemsChange(state, action)),
        changeSidebarInOrders: ((state, action) => onSidebarInOrdersChange(state, action)),
        changeSidebarWithNavigate: ((state, action) => onSidebarSidebarWithNavigateChange(state, action)),
        changeSidebarIsOpen: ((state, action) => onSidebarIsOpenChange(state, action)),
    }
})

export default sidebarSlice.reducer;
export const {changeSidebarItems, changeSidebarInOrders, changeSidebarWithNavigate, changeSidebarIsOpen} = sidebarSlice.actions;
